import { render } from "./App.vue?vue&type=template&id=c950ed28"
const script = {}

import exportComponent from "/Applications/MAMP/htdocs/hv_customer_survey_web_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__